<script lang="ts">
    export let direction: "prev" | "next" = "next";
    export let label: string;
    export let onClick: () => void;
</script>

<button
    type="button"
    class="navBtn {direction}"
    aria-label={label}
    title={label}
    on:click|stopPropagation={onClick}
>
    <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
    >
        {#if direction === "prev"}
            <polyline points="15 18 9 12 15 6" />
        {:else}
            <polyline points="9 18 15 12 9 6" />
        {/if}
    </svg>
</button>

<style lang="scss">
    .navBtn {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        z-index: 3;
        width: 42px;
        height: 42px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0;
        border: none;
        border-radius: 50%;
        background-color: rgba(15, 15, 15, 0.55);
        color: #fff;
        cursor: pointer;
        transition:
            background-color 0.15s ease,
            transform 0.15s ease;

        &:hover {
            background-color: rgba(15, 15, 15, 0.85);
        }

        &:active {
            transform: translateY(-50%) scale(0.94);
        }

        &:focus-visible {
            outline: 2px solid #fff;
            outline-offset: 2px;
        }

        svg {
            width: 22px;
            height: 22px;
        }
    }

    .prev {
        left: 10px;
    }

    .next {
        right: 10px;
    }
</style>
